export const getNameInitials = (username) => {
    const names = username.split(" ");
    return `${names[0].charAt(0)}${names[names.length - 1].charAt(0)}`;
}

export const pad = function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}